import loadFloorTradeDeviationMagnitudes from "../../actions/dashboard/load_floor_trade_deviation_magnitudes";
import useQueryWithState from "../use_query_with_state";
import getCurrentScanFloorTradeDeviationMagnitudes from "../../services/getters/project_getters/get_current_scan_floor_trade_deviation_magnitudes";

const useCurrentScanFloorTradeDeviationMagnitudes = (projectId: string, enabled: boolean = true) =>{
  return useQueryWithState(
    ["useCurrentScanFloorTradeDeviationMagnitudes", projectId],
    loadFloorTradeDeviationMagnitudes,
    getCurrentScanFloorTradeDeviationMagnitudes,
    { enabled: enabled && !!projectId, refetchOnMount: "always" },
    { projectId },
    projectId,
    true
  );
}

export default useCurrentScanFloorTradeDeviationMagnitudes;
